module.exports = __webpack_public_path__ + "static/img/ivana-square.a7842ce3.jpg";